import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { DataContext } from "../contexts/DataContext";

const Main = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Clear the phone's notch / camera cutout on the top edge. */
  padding-top: env(safe-area-inset-top, 0px);
  box-sizing: border-box;
`;
const Title = styled.div`
  font-size: 0.8em;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text_variant};
  margin-bottom: 0.9em;
  text-align: center;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Value = styled.div`
  font-size: 6em;
  font-weight: 400;
  line-height: 1.1;
  min-width: 2ch;
  margin: 0 0.4em;
  text-align: center;
`;
const AdjustButton = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 20px;
  background: linear-gradient(135deg, #1fe39a 0%, #0bbd7d 100%);
  color: #04231a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3em;
  font-weight: 700;
  user-select: none;
  cursor: pointer;
  box-shadow: 0 8px 22px rgba(11, 189, 125, 0.28);
  transition: transform 0.08s ease, filter 0.15s ease;
  &:active {
    transform: translateY(2px);
    filter: brightness(1.06);
  }
`;
const MinusButton = styled(AdjustButton)`
  background: linear-gradient(135deg, #f0466b 0%, #d0163f 100%);
  color: #fff;
  box-shadow: 0 8px 22px rgba(208, 22, 63, 0.26);
`;

export default function FishCountWeighIn() {
  const { data, setFishCountWeighIn } = useContext(DataContext);
  const serverValue = data && data.fishCountWeighIn ? data.fishCountWeighIn : 0;

  // Local value for responsiveness; re-synced whenever the server (or another
  // operator changing it elsewhere) sends a new value.
  const [value, setValue] = useState(serverValue);
  useEffect(() => {
    setValue(serverValue);
  }, [serverValue]);

  // Each press saves immediately, so there is no separate save step.
  function adjust(by) {
    const next = Math.max(value + by, 0);
    setValue(next);
    setFishCountWeighIn(next);
  }

  return (
    <Main>
      <Title>Fish Count Session</Title>
      <Row>
        <MinusButton onClick={() => adjust(-1)}>-</MinusButton>
        <Value>{value}</Value>
        <AdjustButton onClick={() => adjust(1)}>+</AdjustButton>
      </Row>
    </Main>
  );
}
